<div class="reg_container">
    <div class="Page_container">
        <div class="reg_content">
            <div class="title_content">
                <h2>Información al público</h2>
            </div>
            <div class="body-content">
                <p class="subtitle">Información trimestral sobre comisiones y tipos practicados u ofertados de manera
                    más habitual en las
                    operaciones más frecuentes con los perfiles de clientes más comunes que reúnan la condición de
                    consumidor</p>
                <p class="subtitle">ADVERTENCIA:</p>
                <p class="body">La información que se presenta continuación tiene por objeto favorecer la comparación de ciertos
                    productos bancarios frecuentemente ofrecidos a los consumidores en España. <br>

                    Las Informaciones que se reflejan a continuación y en las que se recogen los datos estadísticos de
                    ciertas operaciones estandarizadas con personas físicas , no tiene carácter de oferta ni comprometen
                    en modo alguno a la entidad que las hace públicas.</p>
                    <div class="buttons-container">
                        <a class="main-light-button" href="../../../../assets/pdf/ufasa/Informacion-Trimestral-Sobre-Comisiones-2t-2025.pdf" download><p><img src="../../../../assets/svg/download.svg" alt="descargar"> Descargar documentación</p></a>
                        <a class="main-light-button"  href="../../../../assets/pdf/ufasa/IAC-8769-31-12-20-ANEXOS.pdf" download><p><img src="../../../../assets/svg/download.svg" alt="descargar"> Informe anual del proceso de autoevaluacion del capital de las entidades de crédito (iac) 2020</p></a>    
                    </div>
            </div>
        </div>
    </div>
</div>
<app-footer-landing></app-footer-landing>